import { useFormikContext } from "formik";
import { useEffect, useRef } from "react";

/**
 * Hook permettant de scroller l'écran vers la première erreur dans un formulaire
 *
 * @param fieldName Nom du champ
 * @param fieldRef Reference sur le champ
 */
const useScrollToError = (fieldName: string, fieldRef: any) => {
  const { errors, submitCount, isValid, isSubmitting } = useFormikContext();
  const errorsKeys = Object.keys(errors);
  const prevSubmitCount = useRef(submitCount);
  const firstErrorName = errorsKeys[0];

  useEffect(() => {
    if (!isValid && (prevSubmitCount.current !== submitCount || isSubmitting) && fieldName === firstErrorName) {
      if (fieldRef.current) fieldRef.current!.scrollIntoView({ behavior: "smooth" });
    }
    prevSubmitCount.current = submitCount;
  }, [firstErrorName, isValid, submitCount, isSubmitting, fieldName, fieldRef]);
};

export default useScrollToError;
